import { useAppSelector } from '../hooks'

export const useNotificationsSelector = () => useAppSelector((state) => state.notifications)
